import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollSalaryDetail  {
    _originalTypeClassName = "zERP.BO.PayrollSalaryDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollSalaryDetail.translate = translateService;
}
this.Id = null;
this.Amount = null;
this.OvertimeHours = null;
this.ParameterValue = null;
this.ParameterName = null;
this.From = null;
this.To = null;
this.NeedsParameterValue = false;
this.NeedsDateRange = false;
this.ForEmployee = false;
this.ForEmployer = false;
this.Active = false;
this.BonusIncrease = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Amount:any;
OvertimeHours:any;
ParameterValue:any;
ParameterName:any;
From:any;
To:any;
NeedsParameterValue:any;
NeedsDateRange:any;
ForEmployee:any;
ForEmployer:any;
Active:any;
BonusIncrease:any;
Salary:any;
TaxDetail:any;
ExpressionVersion:any;
ScaleVersion:any;
static setSalary = ($this, value) => {
var oldValue = $this.Salary;
$this.Salary = value;
if (value != null) {
}
}
static setTaxDetail = ($this, value) => {
var oldValue = $this.TaxDetail;
$this.TaxDetail = value;
if (value != null) {
if (oldValue != null && oldValue.Salary != null) { oldValue.Salary = null; }
if ($this.TaxDetail.Salary !== $this) {
Domain.PayrollTaxDetailItem.setSalary(value, $this);
}
}
}
static setExpressionVersion = ($this, value) => {
var oldValue = $this.ExpressionVersion;
$this.ExpressionVersion = value;
if (value != null) {
}
}
static setScaleVersion = ($this, value) => {
var oldValue = $this.ScaleVersion;
$this.ScaleVersion = value;
if (value != null) {
}
}

static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static UpdateOutputVariable($this: any, payroll: any): any{if ($this?.Salary?.OutputVariable == null) {return;}
let variableValue = payroll?.Variables?.linq?.where((v) => v?.Variable == $this?.Salary?.OutputVariable)?.firstOrDefault(null);
if (variableValue != null) {Domain.EmployeePayroll.SetVariableInstanceValue(payroll, variableValue, $this?.Amount);}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}